export default __webpack_public_path__ + "static/media/circleGreenCheck.10530015.svg";